// extracted by mini-css-extract-plugin
export default {"primaryColor":"#232323","secondaryColor":"#d5fff4"};